// Generated by purs version 0.15.0
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Restaumatic_Cart_Detail from "../Restaumatic.Cart.Detail/index.js";
import * as Restaumatic_Cart_ProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic_Menu_V2_Types_CartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
var ProductItem = function (x) {
    return x;
};
var productItemUnitPrice = function (v) {
    return v.unitPrice;
};
var productItemSoftErrors = function (v) {
    return Data_Maybe.fromMaybe([  ])(Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(Data_Either.hush)(v.errors));
};
var productItemQuantity = function (v) {
    return v.quantity;
};
var productItemPrice = function (item) {
    return Data_Functor.map(Data_Maybe.functorMaybe)(function (v) {
        return Data_Numeric.scale(Data_Money_Rounded.scaleIntMoney)(productItemQuantity(item))(v);
    })(productItemUnitPrice(item));
};
var productItemNote = function (v) {
    return v.note;
};
var productItemKey = function (v) {
    return v.key;
};
var productItemFatalError = function (v) {
    return Control_Bind.join(Data_Maybe.bindMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Either.either(Data_Maybe.Just.create)(Data_Function["const"](Data_Maybe.Nothing.value)))(v.errors));
};
var productItemExtendedKey = function (v) {
    return {
        key: v.key,
        note: v.note
    };
};
var productItemErrors = function (v) {
    return v.errors;
};
var productItemDetails = function (v) {
    return v.details;
};
var newtypeProductItem = {
    Coercible0: function () {
        return undefined;
    }
};
var hasNoProductErrors = function (v) {
    if (v.errors instanceof Data_Maybe.Nothing) {
        return true;
    };
    if (v.errors instanceof Data_Maybe.Just && (v.errors.value0 instanceof Data_Either.Right && v.errors.value0.value0.length === 0)) {
        return true;
    };
    return false;
};
var genericProductItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showProductItem = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductItem)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "details";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "errors";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "key";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "note";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "quantity";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "unitPrice";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Money_Rounded.showMoney)))(Data_Show.showInt))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Restaumatic_Cart_ProductKey.showProductKey))(/* #__PURE__ */ Data_Maybe.showMaybe(/* #__PURE__ */ Data_Either.showEither(Restaumatic_Menu_V2_Types_CartToOrder.showFatalError)(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_V2_Types_CartToOrder.showSoftError)))))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Cart_Detail.showProductDetails)))))({
        reflectSymbol: function () {
            return "ProductItem";
        }
    }))
};
export {
    ProductItem,
    hasNoProductErrors,
    productItemDetails,
    productItemErrors,
    productItemFatalError,
    productItemKey,
    productItemNote,
    productItemPrice,
    productItemQuantity,
    productItemSoftErrors,
    productItemUnitPrice,
    productItemExtendedKey,
    newtypeProductItem,
    genericProductItem,
    showProductItem
};
//# sourceMappingURL=index.js.map
